import { FLAG } from 'Utilities/analytics/optimizely/constants';

import { useBinaryExperiment } from '../../experiments/useBinaryExperiment';

export const useShowReturningUserHero = () => {
  const flagVariants = ['control', 'new_ux'];

  const experimentResult = useBinaryExperiment(FLAG.SWA_RETURNERS_ACTIVE_ENQUIRIES, {
    offKey: flagVariants[0],
    onKey: flagVariants[1],
    triggerExperiment: true,
  });

  return { experimentResult };
};
